import React from 'react';

import { styled } from '@material-ui/core/styles';
import { Fade, Typography } from '@material-ui/core';

const PreJoinContiner = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyItems: 'center',
  width: '100%',
  height: '100%',
});

const LightTitle = styled(Typography)({
  fontWeight: 300,
  paddingTop: 15,
  paddingBottom: 15,
});

export default (props) => {
  return (
    <Fade in={true} timeout={{ enter: 500, exit: 0 }}>
      <PreJoinContiner>
        <LightTitle variant="h4" align="center">
          Waiting to start...
        </LightTitle>
        <Typography align="center">
          {props.room?.booking_summary?.practitioner_name} has been notified. Your consult will start automatically.
        </Typography>
      </PreJoinContiner>
    </Fade>
  );
};
